<template>
  <div class="control_bar top">
    <controller
      :dispItems="dispItems"
      :allItems="reserves"
      :router="router"
      @remove="remove"
    >
    </controller>
    <div class="false_modal_window" v-if="showFinishModal">
      <finishModalWindow :question="finishWord" @close="close">
      </finishModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controller from '../controller.vue'
import finishModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'
import importModalWindow from '../modalWindow/importModalWindow.vue'

export default {
  props: ['dispItems'],
  data() {
    return {
      showFinishModal: false,
      finishWord: '',
      router: '/reserve/add',
      showloadingModal: false
    }
  },
  computed: {
    reserves() {
      return this.$store.state.reserve.reserves
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    selectedReserveList() {
      return this.$store.state.reserve.selectedReserveList
    }
  },
  components: {
    controller,
    finishModalWindow,
    loadingModalWindow,
    importModalWindow
  },
  methods: {
    close(e) {
      this.showFinishModal = false
    },
    closeModal(e) {
      this.showFinishModal = false
    },
    async remove(e) {
      const deleteItem = this.selectedReserveList[0]
      this.showloadingModal = true
      try {
        await this.$store.dispatch('reserve/deleteReserve', deleteItem)
        this.$store.dispatch('reserve/clearSelectedReserveList')
        this.finishWord = '対象の予約を削除しました。'
        this.showFinishModal = true
        if (location.pathname !== '/reserve') {
          this.$router.push('/reserve')
        }
        this.$emit('list-reload')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_700001
        let eventType = 9
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          switch (errorMessage) {
            case 'MSGCRC0264':
              this.finishWord =
                this.errorMsg[errorMessage].name +
                this.errorMsg[errorMessage].value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = errorMessage + ' '
              break
            default:
              this.finishWord =
                this.errorMsg.MSGCRC0219.name +
                this.errorMsg.MSGCRC0219.value +
                'エラーコード：{' +
                eventNumber +
                '}'
              reason = 'MSGCRC0219 '
              break
          }
          reason += error.response.status
        } else if (error.response && error.response.data) {
          reason = 'MSGCRC0219'
          eventType = 9
          this.finishWord =
            this.errorMsg.MSGCRC0219.name +
            this.errorMsg.MSGCRC0219.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          reason = 'MSGCRC0005'
          this.finishWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFinishModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
.controller >>> .uploader,
.controller >>> .column_import,
.controller >>> .txt,
.controller >>> .column_import,
.controller >>> .column_export {
  color: #bbb;
  pointer-events: none;
}
.search {
  margin: auto 0;
  height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/reserve/controlbar.vue